import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  broadcasts: [],
  bonusBroadcast: [],
};

export const broadcastsSlice = createSlice({
  name: "broadcasts",
  initialState,
  reducers: {
    setBroadcasts(state, action) {
      state.broadcasts = action.payload;
    },
    setBonusBroadcast(state, action) {
      state.bonusBroadcast = action.payload;
    },
  },
});

export default broadcastsSlice;
